// Хост окна «Новый персонаж» — одна копия в App (как ImageCropHost): места сайта зовут openCharacterCreator и получают
// созданного персонажа. Само окно грузится отдельным куском, когда его впервые открыли.
import { lazy, Suspense, useEffect, useRef, useState } from 'react'
import type { Asset } from '../api/assets'
import { registerCharacterCreatorOpener, type CharacterCreatorRequest } from '../utils/characterCreatorRequest'

const CharacterCreator = lazy(() => import('../pages/assets/creator/CharacterCreator'))

export default function CharacterCreatorHost() {
	const [open, setOpen] = useState<{ key: number; req: CharacterCreatorRequest } | null>(null)
	const pending = useRef<((asset: Asset | null) => void) | null>(null)
	const seq = useRef(0)

	useEffect(() => {
		registerCharacterCreatorOpener((req, resolve) => {
			// Новый вызов при открытом окне — прежний получает «закрыли».
			pending.current?.(null)
			pending.current = resolve
			seq.current += 1
			setOpen({ key: seq.current, req })
		})
		return () => {
			registerCharacterCreatorOpener(null)
			pending.current?.(null)
			pending.current = null
		}
	}, [])

	const done = (asset: Asset | null) => {
		const resolve = pending.current
		pending.current = null
		setOpen(null)
		resolve?.(asset)
	}

	if (!open) return null
	return (
		<Suspense fallback={null}>
			<CharacterCreator key={open.key} request={open.req} onDone={done} />
		</Suspense>
	)
}
